exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n  overflow: auto;\n\n}\n\n#root {\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n}\n\n::-webkit-scrollbar {\n  display: none;\n}\n\nbody {\n  overscroll-behavior-y: none;\n}\n\nhtml {\n  overflow: hidden;\n  height: 100%;\n}\n\n.contextmenu__item {\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n  \n.contextmenu {\n  width: 250px;\n}\n\n.menu {\n  border-bottom: solid 1px #ddd;\n  padding: 10px 0;\n}\n.menu__list {\n  display: flex;\n  flex-wrap: wrap;\n}\n.menu__trigger {\n  display: block;\n  background-color: #f1f1f1;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  font-size: 14px;\n  padding: 10px 20px;\n  transition: 0.2s;\n}\n\n.menu:hover {\n  background-color: #ddd;\n}\n\n#draggable {\n  position: absolute;\n  pointer-events: none;\n  height: 100%;\n  width: 100%;\n}\n\nbutton:focus {\n  outline:0;\n}\n\n.fullWidth {\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/index.css
// module id = ./node_modules/css-loader/index.js!./src/index.css
// module chunks = 0